import React from 'react'
import { Radio, RadioGroup } from '../../../itrust_common/components/form'
import { Field } from 'redux-form'

export default function Accessibility(props) {
  const { setIsReloadRequire, setCurrentZoomLevel } = props

  const zoomLevelFields = [
    { value: '80%', label: 'Extra Small' },
    { value: '90%', label: 'Small' },
    { value: '100%', label: 'Default' },
    { value: '105%', label: 'Large' },
    { value: '110%', label: 'Extra Large' },
    { value: '115%', label: 'Extra Extra Large' },
  ]

  const handleZoomLevelChange = (level) => {
    setCurrentZoomLevel(level)
    setIsReloadRequire(true)
  }

  return (
    <div>
      <h6 className='col-12 mb-4'>Zoom Level</h6>
      <div className='ml-5'>
        {zoomLevelFields.map((field) => <Field name="zoom_level" type="radio" component={Radio} value={`${field.value}`} label={`${field.label}`} wrapperClasses="radio-sm" onChange={() => handleZoomLevelChange(field.value)} />)}
      </div>
      <div className='row border-top mt-6 pt-6'>
        <div className='col-4'>
          <h6 className='pb-2'>Font Appearance</h6>
          <RadioGroup name="preferences.accessibility.font_appearance" btnWrapperClasses="mt-3" options={[{ label: 'Large', value: 'large' }, { label: 'Default', value: 'default' }]} wrapperClasses="form-group" isButtonsNormal={true} />
        </div>
        <div className='col-4'>
          <h6 className='pb-2'>Quick Actions</h6>
          <RadioGroup name="preferences.accessibility.quick_actions" btnWrapperClasses="mt-3" options={[{ label: 'On', value: true }, { label: 'Off', value: false }]} wrapperClasses="form-group" isButtonsNormal={true} />
        </div>
      </div>
    </div>
  )
}